/** @format */
import {forwardRef, ReactNode} from 'react';

import {Close} from '@mui/icons-material';

import {Box} from '@mui/material';

import {CloseButton, ContentBox, HeaderBox, HeaderText} from './styles';

interface Props {
  headerText: string;
  content: ReactNode;
  onClose: () => void;
}

const HelpContent = forwardRef(({headerText, content, onClose}: Props, ref) => {
  return (
    <Box ref={ref}>
      <HeaderBox>
        <HeaderText>{headerText}</HeaderText>
        <CloseButton disableRipple onClick={onClose}>
          <Close />
        </CloseButton>
      </HeaderBox>
      <ContentBox>{content}</ContentBox>
    </Box>
  );
});

HelpContent.displayName = 'HelpContent';

export {HelpContent};
